export default __webpack_public_path__ + "static/media/CNo.64-1.a31d8171.jpg";